import { Link } from 'react-router-dom';

import { Bars3Icon as MenuIcon } from '@heroicons/react/24/outline';

import Logo from '@/assets/svg/logos/primary.svg';

interface IHeader {
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Header: React.FC<IHeader> = ({ setSidebarOpen }) => {
  return (
    <div className="lg:hidden px-2 py-2 sm:px-3 sm:py-3 flex items-center shadow sticky z-9">
      <button
        className="h-10 w-10 inline-flex items-center justify-center rounded-md focus:outline-none"
        onClick={() => setSidebarOpen(true)}
        type="button"
      >
        <span className="sr-only">Open sidebar</span>
        <MenuIcon className="h-6 w-6 text-gray-900" aria-hidden="true" />
      </button>
      <div className="flex-shrink-0 inline-flex items-center">
        <Link to="/">
          <img className="h-7 w-auto" src={Logo} alt="Tapt" />
        </Link>
      </div>
    </div>
  );
};

export { Header as default };
